import styled from 'styled-components';

export const DashboardContainer = styled.div`
  min-height: 100vh;
  background: linear-gradient(to bottom right, #f3f4fb, #f1f4ff);
  padding: 2rem;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
  padding: 1rem 2rem;
  background: white;
  border-radius: 5px;
  border: 1px solid #6366f1;
`;

export const Logo = styled.div`
  display: flex;
  align-items: center;
  gap: 2rem;
`;

export const Title = styled.h1`
  font-family: 'Inter';
  font-size: 1.5rem;
  color: #1a1a1a;
  margin: 0;
  color: #2f77f6;
`;

export const AddButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: #6366f1;
  color: white;
  padding: 0.75rem 1.5rem;
  border-radius: 100px;
  border: none;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #4f46e5;
    transform: translateY(-1px);
  }
`;

export const TabContainer = styled.div`
  background: white;
  border-radius: 5px;
  padding: 1.5rem;
  border: 1px solid #6366f1;
  margin-bottom: 2rem;
`;

export const TabList = styled.div`
  display: flex;
  gap: 1rem;
  border-bottom: 1px solid #6366f1;
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
`;

export const Tab = styled.button`
  padding: 0.5rem 1rem;
  border-radius: 100px;
  border: none;
  font-weight: 500;
  cursor: pointer;
  background: ${(props) => (props.active ? '#6366f1' : 'transparent')};
  color: ${(props) => (props.active ? 'white' : '#6b7280')};
  transition: all 0.2s ease;

  &:hover {
    background: ${(props) => (props.active ? '#4f46e5' : '#f3f4f6')};
  }
`;

export const QuestionCard = styled.div`
  background: white;
  border-radius: 5px;
  border: 1px solid #6366f1;
  padding: 1.5rem;
  margin-bottom: 1rem;
  transition: all 0.2s ease;

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    transform: translateY(-2px);
  }
`;

export const QuestionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
`;

export const QuestionType = styled.span`
  background: #f3f4f6;
  padding: 0.25rem 0.75rem;
  border-radius: 999px;
  font-size: 0.875rem;
  color: #4b5563;
`;

export const ActionButtons = styled.div`
  display: flex;
  gap: 0.5rem;
`;

export const IconButton = styled.button`
  padding: 0.5rem;
  border-radius: 6px;
  border: none;
  background: transparent;
  cursor: pointer;
  color: #6b7280;
  transition: all 0.2s ease;

  &:hover {
    background: #f3f4f6;
    color: #4b5563;
  }
`;

export const Modal = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: white;
  padding: 2rem;
  border-radius: 5px;
  width: 90%;
  max-width: 600px;
  max-height: 600px;
  overflow-y: auto;
  border: 1px solid #2f77f6;

  font-family: 'Inter';
`;

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

export const FormField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const Label = styled.label`
  font-weight: 500;
  color: #374151;
`;

export const Input = styled.input`
  padding: 0.75rem;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  font-size: 1rem;
  transition: all 0.2s ease;

  &:focus {
    outline: none;
    border-color: #6366f1;
    box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);
  }
`;

export const Select = styled.select`
  padding: 0.75rem;
  padding-right: 2.5rem;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  font-size: 1rem;
  background: white;
  cursor: pointer;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%236b7280' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 0.75rem center;
  background-size: 1em;

  &:focus {
    outline: none;
    border-color: #6366f1;
    box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);
  }
`;

export const AddOptionButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  margin-top: 0.5rem;
  padding: 0.5rem 1rem;
  background-color: transparent;
  color: #6366f1;
  border: 1px solid #6366f1;
  border-radius: 6px;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: rgba(99, 102, 241, 0.05);
    border-style: solid;
  }

  &:active {
    transform: translateY(1px);
  }
`;

export const CancelButton = styled.button`
  padding: 0.75rem 1.5rem;
  background-color: transparent;
  color: #6b7280;
  border: 1px solid #e5e7eb;
  border-radius: 100px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: #f3f4f6;
    border-color: #d1d5db;
  }
`;

export const SubmitButton = styled.button`
  padding: 0.75rem 1.5rem;
  color: white;
  border: none;
  border-radius: 100px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  background: linear-gradient(90deg, #7b5cff, #60a5fa);

  &:hover {
    background-color: #4f46e5;
  }

  &:active {
    transform: translateY(1px);
  }
`;

export const BackButton = styled.button`
  padding: 8px 16px;
  background-color: #f3f4f6;
  color: #374151;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 8px;

  &:hover {
    background-color: #e5e7eb;
  }

  &:active {
    background-color: #d1d5db;
  }

  &:focus {
    outline: 2px solid #3b82f6;
    outline-offset: 2px;
  }
`;

export const NextButton = styled.button`
  padding: 8px 16px;
  background-color: #3b82f6;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 8px;

  &:hover {
    background-color: #2563eb;
  }

  &:active {
    background-color: #1d4ed8;
  }

  &:focus {
    outline: 2px solid #93c5fd;
    outline-offset: 2px;
  }
`;

export const FinishButton = styled.button`
  padding: 8px 16px;
  background-color: #10b981;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 8px;

  &:hover {
    background-color: #059669;
  }

  &:active {
    background-color: #047857;
  }

  &:focus {
    outline: 2px solid #6ee7b7;
    outline-offset: 2px;
  }
`;

export const AddSubQuestionButton = styled.button`
  padding: 8px 16px;
  background-color: #8b5cf6;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 8px;

  &:hover {
    background-color: #7c3aed;
  }

  &:active {
    background-color: #6d28d9;
  }

  &:focus {
    outline: 2px solid #c4b5fd;
    outline-offset: 2px;
  }

  svg {
    width: 16px;
    height: 16px;
  }
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid #e5e7eb;
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;
export const BreadcrumbPath = styled.div`
  display: flex;
  gap: 8px;
  font-size: 14px;
  color: #6b7280;
  margin-top: 8px;

  span {
    display: flex;
    align-items: center;
  }
`;

export const ModalHeader = styled.div`
  margin-bottom: 24px;

  h3 {
    margin: 0;
    color: #111827;
    font-size: 18px;
  }
`;
